import React, { useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";

const BotEventCatcher = (props) =>{
  let history = useHistory()


  const incomingActivityListenner = useCallback(event => {
    if(event && event.data){
      //Check message is type event
      if (event.data.type === 'event') {
        
        //dispatch depending on name
        if(event.data.name === "searchEvent"){
          console.log("### searchEvent")

          //value: {Materiel: 'bois', Batiment: 'ecole', "Test ": 'ecole et bois'}
          let eventValues = event.data.value;
          let domaine_formation = '';
          let domaine_professionnel = '';
          let niveau_diplome = '';
          let lieu = '';
          let other = '';

          if(eventValues){
            for (const [key, value] of Object.entries(eventValues)) {
              switch (key) {
                case "domaine_formation":
                  if(value !== '[domaineFormation]')
                    domaine_formation = value;
                  break;
                case "domaine_professionnel":
                  if(value !== '[domaineProfessionnel]')
                    domaine_professionnel = value;
                  break;
                case "niveau_diplome":
                  if(value !== '[niveauDiplome]')
                    niveau_diplome = value;
                  break;
                case "lieu":
                  if(value !== '[lieu]')
                    lieu = value;
                  break;
                default:
                    if(value && value.length > 0 && value.indexOf("[") === -1 && value.indexOf("]") === -1){
                      other+= ` ${value}`; 
                    }
                  break;
              }
              //console.log(`${key}: ${value}`);
            }
          }
          

          //Change page & Fill filters
          /*var filters = {
            fields : "art",
            workFields : "art",
            levels : "bac +5",
            locations : "",
            others : "informatique"
          }*/
          var filters = {
            fields : domaine_formation,
            workFields : domaine_professionnel,
            levels : niveau_diplome,
            locations : lieu,
            others : other
          }
          props.injectFilters(filters)
          history.push("/rechercher")
        }
      }
    }
  }, [history, props]);


  useEffect(()=>{
    window.addEventListener("incomingactivity", incomingActivityListenner);
    return () => {
        window.removeEventListener("incomingactivity", incomingActivityListenner);
    };
  }, [incomingActivityListenner]);

  return(
    <>
    </>
  )
}

export default BotEventCatcher;
